@use "~theme/breakpoints";

.tooltip {
  --tooltip-background-color: var(--blue-04);
  --tooltip-border-color: var(--blue-02-at-30);

  position: relative;
  z-index: var(--float);

  display: flex;
  flex-direction: column;
  align-items: center;

  background-color: var(--tooltip-background-color);
  border-radius: 4px;
  border: 1px solid var(--tooltip-border-color);
  padding: 20px;
}

// Use ::before and ::after pseudo-elements to create 2 arrow shapes.
// One is filled with the tooltip background color, and the other is filled
// with the tooltip border color. We position them slightly offset from
// each other to give the illusion of an outline.
.tooltip::before,
.tooltip::after {
  display: block;
  content: "";
  position: absolute;
  height: 22px;
  width: 22px;
  clip-path: polygon(20% 20%, 80% 80%, 0% 100%);
  transform: rotate(135deg);
  background-color: var(--tooltip-border-color);

  // The arrow points up on mobile, down on desktop.
  @include breakpoints.desktop {
    transform: rotate(-45deg);
  }
}

.tooltip::before {
  border-radius: 0 0 0 5px;
  top: -12px;

  @include breakpoints.desktop {
    top: unset;
    bottom: -12px;
  }
}

.tooltip::after {
  border-radius: 0 0 0 3px;
  top: -10px;
  background-color: var(--tooltip-background-color);

  @include breakpoints.desktop {
    top: unset;
    bottom: -10px;
  }
}
